import { Injectable } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
// RxJs
import { BehaviorSubject } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import {
  FloatLabelType,
  MatFormFieldAppearance,
} from '@angular/material/form-field';

@Injectable({ providedIn: 'root' })
export class PlDesignService {
  private _enabled$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false
  );

  private _sideNavOpened$: BehaviorSubject<boolean> =
    new BehaviorSubject<boolean>(false);

  get enabled$() {
    return this._enabled$.asObservable().pipe(shareReplay());
  }

  components = {
    formField: {
      appearance: <MatFormFieldAppearance>'fill',
      floatLabel: <FloatLabelType>'always',
      hideRequiredMarker: false,
    },
    paginator: {
      sizeOptions: [5, 10, 25, 50, 100],
    },
    datepicker: {
      startView: 'month',
    },
  };

  formats: {
    date: 'M/dd/yyyy';
  };

  settings = {
    paginator: {
      size: 25,
    },
  };

  smallScreen$ = this.breakpointObserver
    .observe([Breakpoints.XSmall, Breakpoints.Small])
    .pipe(
      map(({ matches }) => matches),
      shareReplay()
    );

  constructor(private breakpointObserver: BreakpointObserver) {
    const userSettings = localStorage.getItem('pl_user_settings');
    if (userSettings) {
      this.settings = {
        ...this.settings,
        ...JSON.parse(userSettings),
      };
    }
    this.smallScreen$.subscribe((smallScreen) =>
      this._sideNavOpened$.next(!smallScreen)
    );
  }

  enable() {
    this._enabled$.next(true);
  }

  disable() {
    this._enabled$.next(false);
  }

  setTablePageSize(size: number) {
    if (this.settings.paginator.size === size) {
      return;
    }
    this.settings.paginator.size = size;
    this.saveSettings();
  }

  saveSettings() {
    localStorage.setItem('pl_user_settings', JSON.stringify(this.settings));
  }
}
